import { type SupabaseClient, createClient } from "@supabase/supabase-js";

let supabase: SupabaseClient<any, "public", any>;

export const useSupabase = (options = {}) => {
  if (supabase && Object.keys(options).length === 0) {
    return supabase;
  }

  const client = createClient(
    import.meta.env.VITE_SUPABASE_URL,
    import.meta.env.VITE_SUPABASE_ANON_KEY,
    options
  );

  supabase = client;

  return client;
};
